import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(() => {
  // Extending the String prototype to include padZero
  String.prototype.extractId = function (): string {
    // Assuming the string contains an ID at the end of the URL-like structure
    // Convert the current string instance to a standard string.
    const str = String(this)

    // If a match is found, return the second captured group (the ID part).
    // If no match is found, return the original string.
    return str.includes(':') ? str.split(':')[1] : str
  }
})
